import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const { t } = useTranslation();
  const items = t('faq.items', { returnObjects: true });
  const faqItems = Array.isArray(items) ? items : [];

  return (
    <section id="faq" className="bg-white py-16 sm:py-20 lg:py-28">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[0.72fr_1.28fr] lg:gap-20 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5 }}
          className="lg:sticky lg:top-28 lg:self-start"
        >
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.24em] text-csl-green">
            {t('faq.eyebrow')}
          </p>
          <h2 className="mb-5 text-3xl font-bold leading-tight text-gray-950 sm:text-4xl lg:text-5xl">
            {t('faq.title')}
          </h2>
          <p className="max-w-md text-base leading-relaxed text-gray-600 sm:text-lg">
            {t('faq.description')}
          </p>
          <a
            href="mailto:contact@csl-brands.com"
            className="mt-7 inline-flex border-b border-csl-green pb-1 text-sm font-bold text-csl-green transition-colors hover:border-gray-900 hover:text-gray-900"
          >
            {t('faq.contact')}
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.55, delay: 0.08 }}
        >
          <Accordion type="single" collapsible className="border-t border-gray-900/15">
            {faqItems.map((item, index) => (
              <AccordionItem key={item.question} value={`faq-${index}`} className="border-b border-gray-900/15">
                <AccordionTrigger className="py-6 text-base font-bold leading-snug text-gray-950 no-underline hover:text-csl-green hover:no-underline sm:py-7 sm:text-xl">
                  <span className="flex pr-5 text-left">
                    <span className="mr-4 mt-0.5 text-xs font-bold tracking-wider text-csl-green sm:mr-6">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    {item.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-7 pl-10 pr-8 text-base leading-relaxed text-gray-600 sm:pl-14 sm:pr-12">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
